export default "__VITE_ASSET__4XBYlzzn__"